/* eslint-disable no-undef */
import { ModalRoute } from "react-router-modal";
import React from "react";
import PropTypes from "prop-types";
import "react-router-modal/css/react-router-modal.css";
import { Route } from "react-router-dom";
import AppLayout from "../../../blocks/dashboard/src/AppLayout.web";

const useQueryParams = () => {
  const location = window.location;
  // eslint-disable-next-line no-undef
  const searchParams = new URLSearchParams(location.search);
  const isWidget = searchParams.get("isWidget") === "true";
  const businessId = searchParams.get("businessId");

  const getFullUrl = path => {
    if (!isWidget || !businessId) {
      return path;
    }
    const separator = path.includes("?") ? "&" : "?";
    return `${path}${separator}isWidget=true&businessId=${businessId}`;
  };

  return { isWidget, businessId, getFullUrl };
};

function Wrapper({ element, history, match, routeMap, closeModal }) {
  const { getFullUrl } = useQueryParams();

  const navigate = (to, params) => {
    let url = routeMap[to].path;
    // replace params ids in the url with actual values
    if (params && Object.keys(params).length > 0) {
      Object.keys(params).forEach(param => {
        const re = RegExp(`\:${param}\\??`); // eslint-disable-line no-useless-escape
        url = url.replace(re, escape(params[param]));
      });
    }
    // removing empty params from url - every string between /: and ?
    url = url.replace(/\/:(.*?)(?=\/|$)/g, "");
    // if the route is not a modal
    if (!routeMap[to].modal) {
      history.push(getFullUrl(url));
      // if the route is a modal
    } else {
      // checking if the url ends with a slash or not
      const slash = /\/$/.test(match.url) ? "" : "/";
      // current url in the browser + slash + modal url with parameters
      url = match.url + slash + url;
      // removing the */ from the url
      url = url.replace(/\*\/?/g, "");
      history.push(getFullUrl(url));
    }
  };

  const getParam = (param, alternative) => {
    return match.params[param] || alternative;
  };

  const goBack = () => {
    history.goBack();
  };

  return React.cloneElement(element, {
    navigation: { navigate, getParam, goBack, history },
    closeModal
  });
}

Wrapper.propTypes = {
  element: PropTypes.element,
  history: PropTypes.object,
  routeMap: PropTypes.object,
  closeModal: PropTypes.func,
  match: PropTypes.object
};

const WebRoutesGenerator = ({ routeMap }) => {
  return Object.keys(routeMap).map(route => {
    const currentRoute = routeMap[route];
    const currentRoutePath = currentRoute.path;
    const Component = currentRoute.component;
    if (currentRoute.modal) {
      return (
        <ModalRoute
          key={currentRoutePath}
          path={currentRoutePath}
          component={props => (
            <Wrapper element={<Component />} {...props} routeMap={routeMap} />
          )}
        />
      );
    } else {
      if (currentRoute.layout === true) {
        return (
          <Route
            key={currentRoutePath}
            path={currentRoutePath}
            exact={currentRoute.exact}
            render={props => (
              <Wrapper element={
                <AppLayout>
                  <Component />
                </AppLayout>} {...props} routeMap={routeMap} />
            )}
          />
        );
      } else {
        return (
          <Route
            key={currentRoutePath}
            path={currentRoutePath}
            exact={currentRoute.exact}
            // eslint-disable-next-line sonarjs/no-identical-functions
            render={props => (
              <Wrapper element={<Component />} {...props} routeMap={routeMap} />
            )}
          />
        );
      }
    }
  });
};

WebRoutesGenerator.propTypes = {
  routeMap: PropTypes.object
};

export default WebRoutesGenerator;
